const state = {
  tosAgreed: false
}

const getters = {
  notAgreed: (state) => {
    return !state.tosAgreed
  }
}

const mutations = {
  setToaAgreed (state, tosAgreed) {
    state.tosAgreed = tosAgreed
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
